/*
Closes a native <dialog> element when its ::backdrop is clicked.
A click on the backdrop reports the dialog itself as the event target,
since the click doesn't land on any of the dialog's rendered children.
*/
export default class CloseOnBackdropClick {
  constructor(el) {
    this.el = el;
    this.el.addEventListener("click", this.handleClick);
  }

  handleClick = (event) => {
    if (event.target === this.el) {
      this.el.close();
    }
  };
}
